// extracted by mini-css-extract-plugin
export default {"pageHeader__left":"PageHeader_pageHeader__left__cXHUy","pageHeader__right":"PageHeader_pageHeader__right__1evA8"};